import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { useAssetsStore } from './stores/assets'
import { useErrorCodesStore } from './stores/errorCodes'
import { useAppConfigStore } from './stores/appConfig'
import { initCustomerService, setCustomerServiceUserInfo } from './utils/customerService'
dayjs.extend(duration)

import '@vant/touch-emulator'
import App from './App.vue'
import router from './router'
// 2. 引入组件样式
// import 'vant/lib/index.css'
import 'vant/lib/toast/style'
import 'vant/lib/dialog/style'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(VueQueryPlugin)

app.mount('#app')

// 初始化错误码字典
const errorCodesStore = useErrorCodesStore()
errorCodesStore.fetchErrorCodes()

// 延迟初始化 APP 配置（有缓存则跳过请求）
const appConfigStore = useAppConfigStore()
setTimeout(() => appConfigStore.fetchAppConfig(true), 0)

// 初始化客服管理器
initCustomerService()

// 应用挂载后，如果用户已登录，设置客服访客信息
const assetsStore = useAssetsStore()
if (assetsStore.userProfile) {
  setCustomerServiceUserInfo(assetsStore.userProfile)
}
